import { PageTemplateView } from "@loot-os/design-system/templates/shared/PageTemplateView";

import { useTenant } from "../lib/tenant.js";
import { useForgeContent } from "../templates/pages/forge/useForgeContent.js";
import { storefrontTemplateOf } from "../templates/registry.js";

/** GET /v1/forge/boxes, laid out by the storefront template this environment chose. */
export function ForgePage() {
  const { config } = useTenant();
  return (
    <PageTemplateView template={storefrontTemplateOf(config).forge} content={useForgeContent()} />
  );
}
